import List from "@elements/List/List";
import { ListItem } from "@elements/List/ListItem/ListItem";
import type { ReactElement } from "react";
import { Link } from "react-router-dom";

type BreadCrumbItem = {
  label?: string;
  url?: string;
};

type Props = Readonly<{
  items: BreadCrumbItem[];
}>;

export default function BreadCrumb({ items }: Props): ReactElement {
  return (
    <nav className="mb-4">
      <List className="xs:hidden lg:inline-flex">
        {items.map((item, id) => (
          <ListItem
            key={id}
            className="text-gray-700 text-xs font-normal font-sans"
          >
            {item.url !== undefined ? (
              <>
                <Link
                  reloadDocument
                  to={item.url}
                  className="hover:text-gray-700 hover:underline"
                >
                  {item.label}
                </Link>
                <span className="px-2 text-3xs bottom-1px relative">{">"}</span>
              </>
            ) : (
              <span className="text-gray-950">{item.label}</span>
            )}
          </ListItem>
        ))}
      </List>
    </nav>
  );
}
